var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.446 4.397l.084.073 7 7c.026.025.05.052.071.081l-.07-.081a.75.75 0 01.096.119l.05.09.04.103c.022.068.033.142.033.218l-.002.057-.013.09-.008.038-.035.106-.034.069-.064.098-.064.072-7 7a.75.75 0 01-1.133-.976l.073-.084 5.719-5.72H5a.75.75 0 010-1.5h12.189l-5.72-5.72a.75.75 0 01-.072-.976l.073-.084a.75.75 0 01.976-.073z",
    fill: "currentColor"
  })));
}

export default SvgArrowRight;